import * as store from '@daas-consulting/core-frontend-store';

export class SetDefaultReturnUrl {
  static readonly type = store.getActionName({
    context: 'core',
    feature: 'store',
    section: 'navigation',
    action: 'Set Default Return Url',
  });
  constructor(readonly url: string) {}
}

export class OverrideReturnUrl {
  static readonly type = store.getActionName({
    context: 'core',
    feature: 'store',
    section: 'navigation',
    action: 'Override Return Url',
  });
  constructor(readonly url: string) {}
}

export class GoBack {
  static readonly type = store.getActionName({
    context: 'core',
    feature: 'store',
    section: 'navigation',
    action: 'Go back',
  });
  constructor(readonly extraParams?: Record<string, unknown>) {}
}

export class ClearNavigationStack {
  static readonly type = store.getActionName({
    context: 'core',
    feature: 'store',
    section: 'navigation',
    action: 'Clear navigation stack',
  });
}
